module.exports = __webpack_public_path__ + "media/fonts/Unica77LLTT-Light-4ebf7e098feca777bae13f6813ca7aca.svg";